import React from 'react';
import LocalizedMessage from 'react-l10n';

class PrintButton extends React.Component {
    render() {
        return (
            <button
                className='button button--grey button--small button--thin hidden-xs hidden-sm'
                data-print
            >
                <span className='icon icon-print' />
                <span>
                    <LocalizedMessage id={'PRINT'} />
                </span>
            </button>
        );
    }
}

// default props
PrintButton.defaultProps = {};
// validate props
PrintButton.propTypes = {};

export default PrintButton;
